module.exports = __webpack_public_path__ + "static/img/dz-banner_.7a25d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dz-banner_.png
// module id = mXJt
// module chunks = 18